export default __webpack_public_path__ + "static/media/open-eyes.505987ef.svg";